<template>
    <div>
        <div class="grid grid-cols-1 xl:grid-cols-2 gap-6">

            <!-- Informations générales -->
            <div class="col-span-1 md:col-span-2">
                <div class="border border-gray-200 rounded-xl p-5 bg-white">
                    <h3 class="text-sm font-semibold text-gray-800 mb-1 flex items-center">
                        <i class="fas fa-id-card mr-2 text-gray-500"></i>
                        Informations générales
                    </h3>
                    <p class="text-xs text-gray-500 mb-5">
                        Informations d'identification du technicien.
                    </p>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <!-- Nom -->
                        <div>
                            <label class="text-sm font-medium text-gray-700">Nom</label>
                            <div class="relative mt-1">
                                <i class="fas fa-user absolute left-3 top-3 text-gray-400"></i>
                                <input v-model="tech.nom" type="text" placeholder="Ex : Dupont" class="pl-10 w-full rounded-lg border border-gray-300 text-sm py-2 focus:outline-none" />
                            </div>
                        </div>

                        <!-- Prénom -->
                        <div>
                            <label class="text-sm font-medium text-gray-700">Prénom</label>
                            <div class="relative mt-1">
                                <i class="fas fa-user absolute left-3 top-3 text-gray-400"></i>
                                <input v-model="tech.prenom" type="text" placeholder="Ex : Jean" class="pl-10 w-full rounded-lg border border-gray-300 text-sm py-2 focus:outline-none" />
                            </div>
                        </div>

                        <!-- Email -->
                        <div class="col-span-1 md:col-span-2">
                            <label class="text-sm font-medium text-gray-700">Email</label>
                            <div class="relative mt-1">
                                <i class="fas fa-envelope absolute left-3 top-3 text-gray-400"></i>
                                <input v-model="tech.email" type="email" placeholder="tech@example.fr" class="pl-10 w-full rounded-lg border border-gray-300 text-sm py-2 focus:outline-none" />
                            </div>
                        </div>

                        <!-- Couleur -->
                        <div class="col-span-1 md:col-span-2">
                            <label class="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-2">
                                Couleur
                            </label>

                            <div
                                class="flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-3.5 py-2.5 cursor-pointer hover:border-gray-400 transition-colors"
                                @click="$refs.picker.click()"
                            >
                                <!-- Aperçu couleur -->
                                <div
                                class="w-7 h-7 rounded-lg border border-black/10 flex-shrink-0 transition-colors"
                                :style="{ background: tech.color }"
                                />

                                <!-- Labels hex + rgb -->
                                <div class="flex-1 min-w-0">
                                    <div class="text-sm font-medium font-mono tracking-wide text-gray-900">
                                        {{ tech.color }}
                                    </div>
                                    <div class="text-xs text-gray-400 mt-0.5">
                                        {{ tech.color }}
                                    </div>
                                </div>

                                <!-- Icône palette -->
                                <svg class="w-4 h-4 text-gray-400 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10"/>
                                <path d="M8 12a4 4 0 1 1 8 0"/>
                                <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"/>
                                </svg>

                                <input
                                ref="picker"
                                v-model="tech.color"
                                type="color"
                                class="absolute opacity-0 w-0 h-0 pointer-events-none"
                                />
                            </div>

                            <!-- Couleurs prédéfinies -->
                            <div class="flex flex-wrap gap-2 mt-3">
                                <button
                                v-for="c in presetColors"
                                :key="c"
                                type="button"
                                class="w-6 h-6 rounded-full border border-black/10 transition-transform hover:scale-125"
                                :style="{ background: c, outline: tech.color === c ? '2px solid #111' : 'none', outlineOffset: '2px' }"
                                @click="tech.color = c"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <!-- Optimisation de tournée -->
            <div v-if="false" class="col-span-1 md:col-span-2">
                <div class="border border-gray-200 rounded-xl p-5 bg-white">
                    <h3 class="text-sm font-semibold text-gray-800 mb-1 flex items-center">
                        <i class="fas fa-route mr-2 text-gray-500"></i>
                        Optimisation de tournée
                    </h3>
                    <p class="text-xs text-gray-500 mb-5">
                        Ces adresses sont utilisées pour optimiser les trajets quotidiens.
                    </p>

                    <div class="space-y-4">

                        <!-- Adresse départ -->
                        <div>
                            <label class="text-sm font-medium text-gray-700">
                                Adresse de départ
                            </label>
                            <div class="relative mt-1">
                                <i class="fas fa-play absolute left-3 top-3 text-gray-400"></i>
                                <button
                                    @click="selectedAdresseModal = 'adresse_depart_id'; openAdresseModal()"
                                    class="pl-10 w-full rounded-lg border border-gray-300 text-sm py-2 text-left bg-white"
                                >
                                    <span v-if="adresseLabelDepart">
                                        {{ adresseLabelDepart }}
                                    </span>
                                    <span v-else class="text-gray-400">
                                        Choisir une adresse de départ…
                                    </span>
                                </button>
                            </div>
                        </div>

                        <!-- Adresse retour -->
                        <div>
                            <label class="text-sm font-medium text-gray-700">
                                Adresse de retour
                            </label>
                            <div class="relative mt-1">
                                <i class="fas fa-flag-checkered absolute left-3 top-3 text-gray-400"></i>
                                <button
                                    @click="selectedAdresseModal = 'adresse_retour_id'; openAdresseModal()"
                                    class="pl-10 w-full rounded-lg border border-gray-300 text-sm py-2 text-left bg-white"
                                >
                                    <span v-if="adresseLabelRetour">
                                        {{ adresseLabelRetour }}
                                    </span>
                                    <span v-else class="text-gray-400">
                                        Choisir une adresse de retour…
                                    </span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <!-- Droits -->
            <div class="col-span-1 md:col-span-2">
                <div class="border border-gray-200 rounded-xl p-5 bg-white">
                    <h3 class="text-sm font-semibold text-gray-800 mb-1 flex items-center">
                        <i class="fas fa-user-shield mr-2 text-gray-500"></i>
                        Droits & permissions
                    </h3>
                    <p class="text-xs text-gray-500 mb-5">
                        Activez précisément les accès du technicien.
                    </p>

                    <div class="space-y-3">

                        <!-- Technicien -->
                        <div
                            class="flex items-center justify-between rounded-lg border p-4 transition"
                            :class="tech.can_app_mobile ? 'border-yellow-500 bg-yellow-50' : 'border-gray-200 bg-gray-50'"
                        >
                            <div class="flex items-start space-x-3">
                                <i class="fas fa-wrench text-yellow-500 mt-1"></i>
                                <div>
                                    <p class="text-sm font-medium text-gray-800">
                                        Technicien
                                    </p>
                                    <p class="text-xs text-gray-500">
                                        Accès à l'application mobile pour interventions.
                                    </p>
                                </div>
                            </div>

                            <button
                                @click="tech.can_app_mobile = !tech.can_app_mobile; $forceUpdate(); emitData()"
                                class="relative inline-flex h-6 w-11 items-center rounded-full transition"
                                :class="tech.can_app_mobile ? 'bg-yellow-600' : 'bg-gray-300'"
                            >
                                <span
                                    class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                                    :class="tech.can_app_mobile ? 'translate-x-6' : 'translate-x-1'"
                                ></span>
                            </button>
                        </div>

                        <!-- Facturation -->
                        <div
                            class="flex items-center justify-between rounded-lg border p-4 transition"
                            :class="tech.can_invoice ? 'border-red-500 bg-red-50' : 'border-gray-200 bg-gray-50'"
                        >
                            <div class="flex items-start space-x-3">
                                <i class="fas fa-file-invoice text-red-500 mt-1"></i>
                                <div>
                                    <p class="text-sm font-medium text-gray-800">
                                        Facturation
                                    </p>
                                    <p class="text-xs text-gray-500">
                                        Peut créer et valider des factures.
                                    </p>
                                </div>
                            </div>

                            <button
                                @click="tech.can_invoice = !tech.can_invoice; $forceUpdate(); emitData()"
                                class="relative inline-flex h-6 w-11 items-center rounded-full transition"
                                :class="tech.can_invoice ? 'bg-red-600' : 'bg-gray-300'"
                            >
                                <span
                                    class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                                    :class="tech.can_invoice ? 'translate-x-6' : 'translate-x-1'"
                                ></span>
                            </button>
                        </div>

                        <!-- Interventions -->
                        <div
                            class="flex items-center justify-between rounded-lg border p-4 transition"
                            :class="tech.can_intervention ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-gray-50'"
                        >
                            <div class="flex items-start space-x-3">
                                <i class="fas fa-tools text-blue-500 mt-1"></i>
                                <div>
                                    <p class="text-sm font-medium text-gray-800">
                                        Interventions
                                    </p>
                                    <p class="text-xs text-gray-500">
                                        Peut créer et gérer des interventions.
                                    </p>
                                </div>
                            </div>

                            <button
                                @click="tech.can_intervention = !tech.can_intervention; $forceUpdate(); emitData()"
                                class="relative inline-flex h-6 w-11 items-center rounded-full transition"
                                :class="tech.can_intervention ? 'bg-blue-600' : 'bg-gray-300'"
                            >
                                <span
                                    class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                                    :class="tech.can_intervention ? 'translate-x-6' : 'translate-x-1'"
                                ></span>
                            </button>
                        </div>

                        <!-- Stats -->
                        <div
                            class="flex items-center justify-between rounded-lg border p-4 transition"
                            :class="tech.can_stats ? 'border-green-500 bg-green-50' : 'border-gray-200 bg-gray-50'"
                        >
                            <div class="flex items-start space-x-3">
                                <i class="fas fa-chart-line text-green-500 mt-1"></i>
                                <div>
                                    <p class="text-sm font-medium text-gray-800">
                                        Statistiques
                                    </p>
                                    <p class="text-xs text-gray-500">
                                        Accès aux indicateurs et performances.
                                    </p>
                                </div>
                            </div>

                            <button
                                @click="tech.can_stats = !tech.can_stats; $forceUpdate(); emitData()"
                                class="relative inline-flex h-6 w-11 items-center rounded-full transition"
                                :class="tech.can_stats ? 'bg-green-600' : 'bg-gray-300'"
                            >
                                <span
                                    class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                                    :class="tech.can_stats ? 'translate-x-6' : 'translate-x-1'"
                                ></span>
                            </button>
                        </div>

                        <!-- Stock -->
                        <div
                            class="flex items-center justify-between rounded-lg border p-4 transition"
                            :class="tech.can_stock ? 'border-purple-700 bg-purple-100' : 'border-gray-200 bg-gray-50'"
                        >
                            <div class="flex items-start space-x-3">
                                <i class="fas fa-box text-purple-600 mt-1"></i>
                                <div>
                                    <p class="text-sm font-medium text-gray-800">
                                        Stock
                                    </p>
                                    <p class="text-xs text-gray-500">
                                        Accès à la gestion du stock et des pièces.
                                    </p>
                                </div>
                            </div>

                            <button
                                @click="tech.can_stock = !tech.can_stock; $forceUpdate(); emitData()"
                                class="relative inline-flex h-6 w-11 items-center rounded-full transition"
                                :class="tech.can_stock ? 'bg-purple-700' : 'bg-gray-300'"
                            >
                                <span
                                    class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                                    :class="tech.can_stock ? 'translate-x-6' : 'translate-x-1'"
                                ></span>
                            </button>
                        </div>

                        <!-- Settings -->
                        <div
                            class="flex items-center justify-between rounded-lg border p-4 transition"
                            :class="tech.can_settings ? 'border-gray-700 bg-gray-100' : 'border-gray-200 bg-gray-50'"
                        >
                            <div class="flex items-start space-x-3">
                                <i class="fas fa-cog text-gray-600 mt-1"></i>
                                <div>
                                    <p class="text-sm font-medium text-gray-800">
                                        Paramètres
                                    </p>
                                    <p class="text-xs text-gray-500">
                                        Accès aux réglages avancés.
                                    </p>
                                </div>
                            </div>

                            <button
                                @click="tech.can_settings = !tech.can_settings; $forceUpdate(); emitData()"
                                class="relative inline-flex h-6 w-11 items-center rounded-full transition"
                                :class="tech.can_settings ? 'bg-gray-700' : 'bg-gray-300'"
                            >
                                <span
                                    class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                                    :class="tech.can_settings ? 'translate-x-6' : 'translate-x-1'"
                                ></span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>


            <!-- ───────────────── DOCUMENTS ───────────────── -->
            <div v-if="tech.id" class="col-span-1 md:col-span-2">
                <div class="border border-gray-200 rounded-xl p-5 bg-white">

                    <!-- Header -->
                    <div class="flex items-center justify-between mb-1">
                        <h3 class="text-sm font-semibold text-gray-800 flex items-center">
                            <i class="fas fa-folder-open mr-2 text-gray-500"></i>
                            Documents
                        </h3>
                        <button
                            @click="openDocModal()"
                            class="flex items-center px-3 py-1.5 rounded-lg text-xs font-medium bg-slate-700 text-white hover:bg-slate-800 transition"
                        >
                            <i class="fas fa-plus mr-1.5"></i>
                            Ajouter
                        </button>
                    </div>
                    <p class="text-xs text-gray-500 mb-5">
                        Attestations, habilitations et autres pièces du technicien.
                    </p>

                    <!-- Chargement -->
                    <div v-if="loadingDocs" class="flex items-center justify-center py-8 text-gray-400">
                        <i class="fas fa-spinner fa-spin mr-2"></i>
                        <span class="text-sm">Chargement…</span>
                    </div>

                    <!-- Liste vide -->
                    <div
                        v-else-if="docs.length === 0"
                        class="flex flex-col items-center justify-center py-8 rounded-lg border border-dashed border-gray-200 bg-gray-50 text-gray-400"
                    >
                        <i class="fas fa-file-alt text-2xl mb-2"></i>
                        <p class="text-sm">Aucun document enregistré</p>
                    </div>

                    <!-- Liste des documents -->
                    <div v-else class="space-y-2">
                        <div
                            v-for="doc in docs"
                            :key="doc.id"
                            class="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 hover:bg-gray-100 transition"
                        >
                            <!-- Icône + infos -->
                            <div class="flex items-center space-x-3 min-w-0">
                                <div class="flex-shrink-0 w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center">
                                    <i class="fas fa-file-pdf text-slate-500 text-sm"></i>
                                </div>
                                <div class="min-w-0">
                                    <p class="text-sm font-medium text-gray-800 truncate">
                                        {{ getDocTypeLabel(doc.type) }}
                                    </p>
                                    <div class="flex items-center space-x-2 mt-0.5">
                                        <!-- Badge expiration -->
                                        <template v-if="doc.date_expiration">
                                            <span
                                                class="text-xs font-medium px-1.5 py-0.5 rounded"
                                                :class="isExpired(doc.date_expiration)
                                                    ? 'bg-red-100 text-red-600'
                                                    : isExpiringSoon(doc.date_expiration)
                                                        ? 'bg-orange-100 text-orange-600'
                                                        : 'bg-green-100 text-green-600'"
                                            >
                                                <i class="fas fa-calendar-alt mr-1"></i>
                                                {{ formatDate(doc.date_expiration) }}
                                                <template v-if="isExpired(doc.date_expiration)"> — Expiré</template>
                                                <template v-else-if="isExpiringSoon(doc.date_expiration)"> — Bientôt</template>
                                            </span>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <!-- Actions -->
                            <div class="flex items-center space-x-2 flex-shrink-0 ml-3">
                                <a
                                    v-if="doc.url"
                                    :href="doc.url"
                                    target="_blank"
                                    class="text-gray-400 hover:text-slate-600 transition"
                                >
                                    <i class="fas fa-eye"></i>
                                </a>
                                <button
                                    @click="openDocModal(doc)"
                                    class="text-gray-400 hover:text-slate-600 transition"
                                    title="Modifier"
                                >
                                    <i class="fas fa-pen"></i>
                                </button>
                                <button
                                    @click="deleteDoc(doc)"
                                    class="text-gray-400 hover:text-red-500 transition"
                                    title="Supprimer"
                                >
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ───────────────── FIN DOCUMENTS ───────────────── -->


            <!-- Signature -->
            <div v-if="tech.id" class="col-span-1 md:col-span-2">
                <div class="border border-gray-200 rounded-xl p-5 bg-white">
                    <h3 class="text-sm font-semibold text-gray-800 mb-1 flex items-center">
                        <i class="fas fa-pen-nib mr-2 text-gray-500"></i>
                        Signature du technicien
                    </h3>
                    <p class="text-xs text-gray-500 mb-4">
                        Utilisée pour les documents et validations officielles.
                    </p>

                    <!-- Signature existante -->
                    <div v-if="tech.signature" class="flex items-center justify-between">
                        <div class="flex items-center space-x-4">
                            <div class="border rounded-lg bg-gray-50 p-3">
                                <img
                                    :src="tech.signature"
                                    alt="Signature"
                                    class="h-16 object-contain"
                                />
                            </div>

                            <div>
                                <p class="text-sm font-medium text-gray-800">
                                    Signature enregistrée
                                </p>
                                <p class="text-xs text-gray-500">
                                    Cette signature sera automatiquement utilisée.
                                </p>
                            </div>
                        </div>

                        <button
                            @click="removeSignature"
                            class="text-sm text-red-600 hover:text-red-700 hover:underline flex items-center"
                        >
                            <i class="fas fa-trash mr-1"></i>
                            Supprimer
                        </button>
                    </div>

                    <!-- Aucune signature -->
                    <div
                        v-else
                        class="flex items-center justify-between rounded-lg border border-dashed p-4 bg-gray-50"
                    >
                        <div class="flex items-start space-x-3">
                            <i class="fas fa-exclamation-circle text-gray-400 mt-1"></i>
                            <div>
                                <p class="text-sm font-medium text-gray-800">
                                    Aucune signature
                                </p>
                                <p class="text-xs text-gray-500">
                                    Le technicien pourra l'ajouter depuis son espace personnel.
                                </p>
                            </div>
                        </div>

                        <span class="text-xs text-gray-400 italic">
                            En attente
                        </span>
                    </div>
                </div>
            </div>

            <!-- Envoyer lien connexion -->
            <div v-if="tech.id" class="col-span-1 md:col-span-2">
                <div class="border border-gray-200 rounded-xl p-5 bg-white">
                    <h3 class="text-sm font-semibold text-gray-800 mb-1 flex items-center">
                        <i class="fas fa-qrcode mr-2 text-gray-500"></i>
                        Envoyer le lien de connexion
                    </h3>
                    <p class="text-xs text-gray-500 mb-3">
                        Permet au technicien d'accéder à son espace dédié sur l'application mobile.
                    </p>

                    <button :disabled="loadingSendQrCode" @click="sendQrCode" class="flex items-center px-4 py-2 rounded-lg text-sm font-medium bg-slate-600 text-white hover:bg-slate-700 transition">
                        <template v-if="loadingSendQrCode">
                            <i class="fas fa-spinner fa-spin mr-2"></i>
                            Envoi en cours...
                        </template>
                        <template v-if="!loadingSendQrCode">
                            <i class="fas fa-paper-plane mr-2"></i>
                            Envoyer le lien par email
                        </template>
                    </button>
                </div>
            </div>


            <!-- Suppression du technicien -->
            <template v-if="tech.id">
                <div class="col-span-1 md:col-span-2">
                    <div class="relative inline-block">
                        <button @click="displayDelete = !displayDelete" class="flex items-center px-4 py-2 rounded-lg text-sm font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 transition">
                            <template v-if="displayDelete">
                                <i class="fas fa-chevron-down mr-2"></i>
                            </template>
                            <template v-else>
                                <i class="fas fa-chevron-right mr-2"></i>
                            </template>
                            Plus d'options
                        </button>
                    </div>
                </div>
                <div v-if="displayDelete" class="col-span-1 md:col-span-2">
                    <div class="border border-red-200 rounded-xl p-5 bg-red-50">
                        <h3 class="text-sm font-semibold text-red-700 mb-1 flex items-center">
                            <i class="fas fa-exclamation-triangle mr-2"></i>
                            Zone dangereuse
                        </h3>
                        <p class="text-xs text-red-600 mb-4">
                            La suppression d'un technicien est définitive.
                        </p>

                        <div>
                            <div class="text-xs text-red-700">
                                <p>
                                    Le technicien sera supprimé ainsi que ses accès.
                                </p>
                                <p class="opacity-80">
                                    Les interventions existantes ne seront pas supprimées.
                                </p>
                            </div>

                            <button
                                @click="confirmDeleteTech"
                                class="flex items-center px-4 py-2 rounded-lg text-sm font-medium
                                    bg-red-600 text-white hover:bg-red-700 transition mt-4"
                            >
                                <i class="fas fa-trash mr-2"></i>
                                Supprimer le technicien
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <!-- Modal Adresse -->
        <modal name="modal-tech-adresse" width="700" height="auto">
            <div class="p-6">
                <div class="flex items-center justify-between gap-4 mb-4">
                    <h3 class="text-lg font-semibold">
                        <template v-if="selectedAdresseModal == 'adresse_depart_id'">
                            <template v-if="adresseLabelDepart">Modifier l'adresse de départ</template>
                            <template v-else>Ajouter une adresse de départ</template>
                        </template>
                        <template v-else-if="selectedAdresseModal == 'adresse_retour_id'">
                            <template v-if="adresseLabelRetour">Modifier l'adresse de retour</template>
                            <template v-else>Ajouter une adresse de retour</template>
                        </template>
                    </h3>
                    <button @click="closeAdresseModal" class="text-red-400 hover:text-red-600">
                        <i class="fas fa-times fa-lg"></i>
                    </button>
                </div>

                <input-adresse v-model="adresseForm" :min="true"></input-adresse>

                <div class="mt-6 flex justify-end space-x-4">
                    <button @click="closeAdresseModal" class="px-4 py-2 bg-gray-200 rounded-lg text-sm">
                        Annuler
                    </button>

                    <button @click="saveAdresseModal" class="px-4 py-2 bg-red-600 text-white rounded-lg text-sm">
                        Enregistrer
                    </button>
                </div>
            </div>
        </modal>


        <!-- ───────── Modal Document ───────── -->
        <modal name="modal-tech-doc" width="540" height="auto">
            <div class="p-6">

                <!-- Header -->
                <div class="flex items-center justify-between mb-5">
                    <h3 class="text-base font-semibold text-gray-900">
                        {{ docForm.id ? 'Modifier le document' : 'Ajouter un document' }}
                    </h3>
                    <button @click="closeDocModal" class="text-gray-400 hover:text-gray-600">
                        <i class="fas fa-times fa-lg"></i>
                    </button>
                </div>

                <div class="space-y-4">

                    <!-- Type de document -->
                    <div>
                        <label class="text-sm font-medium text-gray-700">
                            Type de document <span class="text-red-500">*</span>
                        </label>
                        <div class="relative mt-1">
                            <i class="fas fa-tag absolute left-3 top-3 text-gray-400 pointer-events-none"></i>
                            <select
                                v-model="docForm.type"
                                class="pl-10 w-full rounded-lg border border-gray-300 text-sm py-2 bg-white focus:outline-none"
                                :class="docErrors.type ? 'border-red-400' : ''"
                            >
                                <option value="" disabled>Choisir un type…</option>
                                <option v-for="opt in docTypes" :key="opt.value" :value="opt.value">
                                    {{ opt.label }}
                                </option>
                            </select>
                        </div>
                        <p v-if="docErrors.type" class="text-xs text-red-500 mt-1">
                            <i class="fas fa-exclamation-circle mr-1"></i>{{ docErrors.type }}
                        </p>
                    </div>

                    <!-- Date d'expiration (optionnelle) -->
                    <div>
                        <label class="text-sm font-medium text-gray-700">
                            Date d'expiration
                            <span class="text-gray-400 font-normal">(optionnelle)</span>
                        </label>
                        <div class="relative mt-1">
                            <i class="fas fa-calendar-alt absolute left-3 top-3 text-gray-400"></i>
                            <input
                                v-model="docForm.date_expiration"
                                type="date"
                                class="pl-10 w-full rounded-lg border border-gray-300 text-sm py-2 focus:outline-none"
                            />
                        </div>
                    </div>

                    <!-- Fichier -->
                    <div>
                        <label class="text-sm font-medium text-gray-700">
                            Fichier <span class="text-red-500">*</span>
                        </label>
 
                        <!-- Mode édition : fichier déjà présent -->
                        <div v-if="docForm.id && docForm.url && !docChangeFile" class="mt-1 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-2.5">
                            <div class="flex items-center space-x-2 text-sm text-gray-700">
                                <i class="fas fa-file-alt text-gray-400"></i>
                                <span>Fichier enregistré</span>
                            </div>
                            <div class="flex items-center space-x-3">
                                <a
                                    :href="docForm.url"
                                    target="_blank"
                                    class="text-xs text-slate-600 hover:text-slate-800 font-medium flex items-center"
                                >
                                    <i class="fas fa-eye mr-1"></i> Consulter
                                </a>
                                <span class="text-gray-300">|</span>
                                <button
                                    type="button"
                                    @click="docChangeFile = true"
                                    class="text-xs text-slate-600 hover:text-slate-800 font-medium flex items-center"
                                >
                                    <i class="fas fa-exchange-alt mr-1"></i> Modifier
                                </button>
                            </div>
                        </div>
 
                        <!-- Input fichier (ajout ou remplacement) -->
                        <div v-else class="mt-1">
                            <div v-if="docForm.id && docChangeFile" class="flex items-center justify-between mb-2">
                                <span class="text-xs text-gray-500">Choisir un nouveau fichier</span>
                                <button
                                    type="button"
                                    @click="docChangeFile = false"
                                    class="text-xs text-gray-400 hover:text-gray-600"
                                >
                                    <i class="fas fa-arrow-left mr-1"></i> Annuler
                                </button>
                            </div>
                            <input-file
                                :key-name="`doc-tech-${tech.id}-${docChangeFile}`"
                                v-model="docForm.url"
                            />
                        </div>
 
                        <p v-if="docErrors.url" class="text-xs text-red-500 mt-1">
                            <i class="fas fa-exclamation-circle mr-1"></i>{{ docErrors.url }}
                        </p>
                    </div>

                </div>

                <!-- Actions -->
                <div class="mt-6 flex justify-end space-x-3">
                    <button
                        @click="closeDocModal"
                        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm hover:bg-gray-300 transition"
                    >
                        Annuler
                    </button>
                    <button
                        @click="saveDoc"
                        :disabled="loadingSaveDoc"
                        class="flex items-center px-4 py-2 bg-slate-700 text-white rounded-lg text-sm hover:bg-slate-800 transition"
                    >
                        <template v-if="loadingSaveDoc">
                            <i class="fas fa-spinner fa-spin mr-2"></i>
                            Enregistrement…
                        </template>
                        <template v-else>
                            <i class="fas fa-save mr-2"></i>
                            {{ docForm.id ? 'Mettre à jour' : 'Enregistrer' }}
                        </template>
                    </button>
                </div>

            </div>
        </modal>
        <!-- ───────── Fin Modal Document ───────── -->


        <!-- Modale confirmation suppression technicien -->
        <modal name="confirm-delete-tech" width="480" height="auto">
            <div class="p-6">

                <!-- Header -->
                <div class="flex items-start space-x-3 mb-4">
                    <div class="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                        <i class="fas fa-trash text-red-600"></i>
                    </div>
                    <div>
                        <h3 class="text-lg font-semibold text-gray-900">
                            Supprimer le technicien
                        </h3>
                        <p class="text-sm text-gray-500">
                            Cette action est définitive.
                        </p>
                    </div>
                </div>

                <!-- Message -->
                <div class="text-sm text-gray-700 space-y-2 mb-6">
                    <p>
                        Vous êtes sur le point de supprimer le technicien
                        <span class="font-semibold">{{ tech.prenom }} {{ tech.nom }}</span>.
                    </p>
                    <p class="text-red-600">
                        • Ses accès seront supprimés<br />
                        • Cette action est irréversible
                    </p>
                    <p class="text-gray-500 text-xs">
                        Les interventions existantes ne seront pas supprimées.
                    </p>
                </div>

                <!-- Actions -->
                <div class="flex justify-end space-x-3">
                    <button
                        @click="$modal.hide('confirm-delete-tech')"
                        class="px-4 py-2 rounded-lg text-sm bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
                    >
                        Annuler
                    </button>

                    <button
                        :disabled="loadingDelete"
                        @click="deleteTech"
                        class="px-4 py-2 rounded-lg text-sm bg-red-600 text-white hover:bg-red-700 transition"
                    >
                        <template v-if="loadingDelete">
                            <i class="fas fa-spinner fa-spin mr-2"></i>
                            Suppression...
                        </template>
                        <template v-if="!loadingDelete">
                            Supprimer définitivement
                        </template>
                    </button>
                </div>

            </div>
        </modal>


    </div>
</template>

<script>
import InputAdresse from '@/components/InputAdresse.vue';

export default {
    components: {
        InputAdresse
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            tech: { ...this.value },

            // Adresses
            adresseForm: {},
            adresseLabelDepart: null,
            adresseLabelRetour: null,
            selectedAdresseModal: '',

            // UI
            displayDelete: false,
            loadingDelete: false,
            loadingSendQrCode: false,

            // Documents
            docs: [],
            loadingDocs: false,
            loadingSaveDoc: false,
            docForm: this.emptyDocForm(),
            docErrors: {},
            docChangeFile: false,

            docTypes: [
                { value: 'attestation_capacite',   label: 'Attestation de capacité (F-Gaz)' },
                { value: 'habilitation_electrique', label: 'Habilitation électrique' },
                { value: 'carte_btp',               label: 'Carte BTP' },
                { value: 'permis_conduire',         label: 'Permis de conduire' },
                { value: 'diplome',                 label: 'Diplôme / Certification' },
                { value: 'visite_medicale',         label: 'Visite médicale d\'aptitude' },
                { value: 'cni_passeport',           label: 'Carte d\'identité / Passeport' },
                { value: 'caces',                   label: 'CACES' },
                { value: 'sst',                     label: 'SST (Sauveteur Secouriste du Travail)' },
                { value: 'autre',                   label: 'Autre' },
            ],

            presetColors: [
                '#ef4444','#f97316','#eab308','#22c55e',
                '#06b6d4','#6366f1','#a855f7','#ec4899',
                '#64748b','#808080','#0f172a'
            ]
        };
    },

    methods: {

        // ─── Adresses ───────────────────────────────────────────────
        openAdresseModal() {
            // Pré-remplir avec l'adresse existante si elle existe
            const existingKey = this.selectedAdresseModal === 'adresse_depart_id'
                ? 'adresse_depart'
                : 'adresse_retour'
            const existing = this.tech[existingKey]
            this.adresseForm = existing ? { ...existing } : {}
            this.$modal.show('modal-tech-adresse')
        },

        closeAdresseModal() {
            this.$modal.hide('modal-tech-adresse');
        },

        async saveAdresseModal() {
            const validation = this.$inpError([
                'inp-adresse1:required|min=5',
                'inp-code_postal:required|postal',
                'inp-ville:required|min=2',
                'inp-pays:required|min=2'
            ])
            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            this.adresseForm.no_client = 1
            const response = await this.$request.post('/clients/0/adresses', this.adresseForm)
            
            const label = [
                this.adresseForm.adresse1,
                this.adresseForm.code_postal,
                this.adresseForm.ville
            ].filter(Boolean).join(' ')

            this.tech[this.selectedAdresseModal] = response.id

            if (this.selectedAdresseModal === 'adresse_depart_id') {
                this.adresseLabelDepart = label
            } else if (this.selectedAdresseModal === 'adresse_retour_id') {
                this.adresseLabelRetour = label
            }

            this.$modal.hide('modal-tech-adresse')
        },

        // ─── Signature ──────────────────────────────────────────────
        removeSignature() {
            this.tech.signature = null;
        },

        // ─── Suppression technicien ─────────────────────────────────
        confirmDeleteTech() {
            this.$modal.show('confirm-delete-tech');
        },

        async deleteTech() {
            try {
                this.loadingDelete = true;
                let response = await this.$request.post(`/techniciens/delete/${this.tech.id}`);
                this.loadingDelete = false;
                if (!response.valid) {
                    this.$toast.error(response.message);
                    return;
                }
                this.$modal.hide('confirm-delete-tech');
                this.$toast.success('Technicien supprimé');
                this.$emit('deleted');
            } catch (e) {
                this.$toast.error('Erreur lors de la suppression');
            }
        },

        // ─── QR Code ────────────────────────────────────────────────
        async sendQrCode() {
            this.loadingSendQrCode = true;
            let response = await this.$request.post('/mobile/send-code', {
                email: this.tech.email,
            });
            this.loadingSendQrCode = false;
            if (response == 1) {
                this.$toast.success('Lien envoyé par email');
            } else {
                this.$toast.error('Erreur lors de l\'envoi du lien');
            }
        },

        // ─── Emit ────────────────────────────────────────────────────
        emitData() {
            this.$emit('input', { ...this.tech });
        },

        // ─── Documents ──────────────────────────────────────────────
        emptyDocForm() {
            return {
                id: null,
                type: '',
                date_expiration: '',
                url: '',
            };
        },

        async fetchDocs() {
            if (!this.tech.id) return;
            this.loadingDocs = true;
            try {
                let response = await this.$request.get(`/accounts/${this.tech.id}/docs`);
                this.docs = response.data || [];
            } catch (e) {
                this.$toast.error('Erreur lors du chargement des documents');
            }
            this.loadingDocs = false;
        },

        openDocModal(doc = null) {
            this.docErrors = {};
            this.docChangeFile = false;
            if (doc) {
                this.docForm = {
                    id: doc.id,
                    type: doc.type,
                    date_expiration: doc.date_expiration ? doc.date_expiration.slice(0, 10) : '',
                    url: doc.url || '',
                };
            } else {
                this.docForm = this.emptyDocForm();
            }
            this.$modal.show('modal-tech-doc');
        },

        closeDocModal() {
            this.$modal.hide('modal-tech-doc');
        },

        validateDocForm() {
            const errors = {};
            if (!this.docForm.type) {
                errors.type = 'Le type de document est obligatoire.';
            }
            if (!this.docForm.url) {
                errors.url = 'Le fichier est obligatoire.';
            }
            this.docErrors = errors;
            return Object.keys(errors).length === 0;
        },

        async saveDoc() {
            if (!this.validateDocForm()) return;

            this.loadingSaveDoc = true;
            try {
                const payload = {
                    type: this.docForm.type,
                    date_expiration: this.docForm.date_expiration || null,
                    url: this.docForm.url,
                };

                if (this.docForm.id) {
                    await this.$request.post(
                        `/accounts/${this.tech.id}/docs/${this.docForm.id}`,
                        payload
                    );
                    this.$toast.success('Document mis à jour');
                } else {
                    await this.$request.post(
                        `/accounts/${this.tech.id}/docs`,
                        payload
                    );
                    this.$toast.success('Document ajouté');
                }

                this.closeDocModal();
                await this.fetchDocs();
            } catch (e) {
                this.$toast.error('Erreur lors de l\'enregistrement');
            }
            this.loadingSaveDoc = false;
        },

        async deleteDoc(doc) {
            if (!confirm(`Supprimer "${this.getDocTypeLabel(doc.type)}" ?`)) return;
            try {
                await this.$request.delete(`/accounts/${this.tech.id}/docs/${doc.id}`);
                this.$toast.success('Document supprimé');
                await this.fetchDocs();
            } catch (e) {
                this.$toast.error('Erreur lors de la suppression');
            }
        },

        // ─── Helpers date ────────────────────────────────────────────
        getDocTypeLabel(value) {
            const found = this.docTypes.find(t => t.value === value);
            return found ? found.label : value;
        },

        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
        },

        isExpired(dateStr) {
            if (!dateStr) return false;
            return new Date(dateStr) < new Date();
        },

        isExpiringSoon(dateStr) {
            if (!dateStr) return false;
            const limit = new Date();
            limit.setDate(limit.getDate() + 60); // 60 jours
            const exp = new Date(dateStr);
            return exp >= new Date() && exp <= limit;
        },
    },

    watch: {
        value: {
            deep: true,
            handler(v) {
                if (JSON.stringify(v) !== JSON.stringify(this.tech)) {
                    this.tech = { ...v };
                }
            }
        },
        tech: {
            deep: true,
            handler(v) {
                if (JSON.stringify(v) !== JSON.stringify(this.value)) {
                    this.emitData();
                }
            }
        }
    },

    mounted() {
        if (this.tech.adresse_depart?.adresse1) {
            this.adresseLabelDepart =
                this.tech.adresse_depart.adresse1 + ', ' +
                this.tech.adresse_depart.code_postal + ' ' +
                this.tech.adresse_depart.ville
        }
        if (this.tech.adresse_retour?.adresse1) {
            this.adresseLabelRetour =
                this.tech.adresse_retour.adresse1 + ', ' +
                this.tech.adresse_retour.code_postal + ' ' +
                this.tech.adresse_retour.ville
        }
        if (this.tech.id) {
            this.fetchDocs()
        }
    },
};
</script>